import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

/**
 * InfoTooltip - Displays information when hovering or clicking an info icon
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to display in the tooltip
 * @param {string} props.position - Position of tooltip (default: 'bottom')
 * @param {string} props.iconSize - Size of the icon (default: 'sm')
 */
const InfoTooltip = ({ children, position = 'bottom', iconSize = 'sm' }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  
  // Determine positioning classes based on the position prop
  const getPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'top-full mb-2 right-0 sm:-left-28';
      case 'left':
        return 'right-full mr-2 top-0';
      case 'right':
        return 'left-full ml-2 top-0';
      case 'bottom':
      default:
        return 'bottom-full mb-2 right-0 sm:-left-28';
    }
  };
  
  // Determine arrow position classes based on the position prop
  const getArrowClasses = () => {
    switch (position) {
      case 'top':
        return '-top-1.5 right-4 sm:left-1/2 sm:-ml-1.5 rotate-45';
      case 'left':
        return 'top-3 -right-1.5 rotate-45';
      case 'right':
        return 'top-3 -left-1.5 rotate-45';
      case 'bottom':
      default:
        return '-bottom-1.5 right-4 sm:left-1/2 sm:-ml-1.5 rotate-45';
    }
  };
  
  const positionClasses = getPositionClasses();
  const arrowClasses = getArrowClasses();
  
  return (
    <div className="relative inline-block">
      <button 
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip(!showTooltip)}
        className="text-medium-grey hover:text-dark-grey p-1 rounded-full focus:outline-none"
        aria-label="Information"
      >
        <FontAwesomeIcon icon={faCircleInfo} size={iconSize} />
      </button>
      {showTooltip && (
        <div className={`absolute z-10 w-64 px-4 py-3 text-sm text-left bg-white border border-gray-200 rounded-lg shadow-lg dark:bg-gray-700 ${positionClasses}`}>
          {children}
          <div className={`absolute w-3 h-3 rotate-45 bg-white border-b border-r border-gray-200 ${arrowClasses}`}></div>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip; 